<template>
  <div class="container">
    <div class="inline-wrapper">
      <div class="risk-left">
        <span style="margin-right: 10px;">User Limit: {{form.riskLevel}}</span>
        <span style="margin-right: 10px;">User Limit ID: {{queryData.riskLevelId}}</span>
        <span>User Count: {{form.userCount}}</span>
      </div>
      <div class="inline-right risk-right">
        <span v-if="form.createTime">Set Time: {{ formatUtc(form.createTime) }}</span>
        <span v-if="form.updateTime">Last Modify Time: {{ formatUtc(form.updateTime) }}</span>
        <span>Last Modifer: {{form.updateUser}}</span>
      </div>
    </div>

    <div>
      <sportTable
        :list="list"
        :loading="loading"
        :isinput="false"
        :iskey="'riskLevelDetailDTOList'"
      />
    </div>

    <div class="remark-wrapper">
      <div class="remark-head">Remark</div>
      <div class="remark-contain text-remark-contain">{{remark}}</div>
    </div>

    <div class="btn-wrapper middle-btn">
      <el-button class="modify-btn" @click="handleViewDetail()">Modify</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import sportTable from "@/components/sportTable/index";
import { getRiskDetailsList } from "@/api/risk";
export default {
  data() {
    return {
      form: {
        riskLevel: "",
        userCount: "",
        riskLevelId: 0,
        updateTime: "",
        createTime: "",
        updateUser: ""
      },
      remark: "",
      list: [],
      loading: false,
      queryData: {
        riskLevelId: 0
      },
      statusList: [
        { key: "-1", val: "", name: "All" },
        { key: "1", val: 1, name: "Active" },
        { key: "0", val: 0, name: "Suspended" }
      ]
    };
  },
  methods: {
    async getList() {
      this.queryData = this.$route.query;
      this.loading = true;
      try {
        const res = await getRiskDetailsList(this.queryData);
        const data = res.data || {};
        this.form.riskLevel = data.riskLevel;
        this.form.userCount = data.userCount;
        this.form.createTime = data.createTime;
        this.form.updateTime = data.updateTime;
        this.form.updateUser = data.updateUser;
        this.remark = data.remark;
        let selfRisk = data.selfRisk;
        let dataList = data.riskLevelDetailDTOList || [];
        for (var key in dataList) {
          dataList[key].selfRisk = selfRisk
        }
        data.riskLevelDetailDTOList = dataList
        this.list = [data] || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 修改
    handleViewDetail() {
      this.$router.push({
        path: "/risk/modify",
        query: { riskLevelId: this.queryData.riskLevelId }
      });
    }
  },
  components: {
    sportTable
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.inline-wrapper {
  margin: 20px 0;
  font-size: 12px;
  .risk-left {
    width: 30%;
  }
  .risk-right {
    width: 70%;
  }
}
.btn-wrapper {
  margin: 20px 0 0 0;
}
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
</style>
